export default __webpack_public_path__ + "static/media/img_company_header22.46780621.png";